export default __webpack_public_path__ + "static/project-slide-8-992-765-c805991f1fc9734d28253131c7613dd9.jpg";